import React from 'react';

const DefaultMessage: React.FC = () => {
    return (
        <div style={{ textAlign: 'center', padding: '50px', fontSize: '1.25em' }}>
            <p style={{ marginBottom: '5px' }}>
                <strong style={{ fontWeight: 'bold' }}>Time Between Events:</strong> Add a second event to use this feature.
            </p>
            <p style={{ fontSize: '0.85em', marginTop: '5px' }}>
                (Mean, median, minimum and maximum time between two healthcare events will be calculated)
            </p>
        </div>
    );
};

export default DefaultMessage;
